import { useRecoilValue } from "recoil";
import { hexDetailIdAtom, mapDataAtom, navIndex } from "../lib/atoms";
import Bestiary from "./Panels/Bestiary";
import Info from "./Panels/Info";
import Items from "./Panels/Items";
import NPCs from "./Panels/NPCs";

export default function InfoBox() {
    const index = useRecoilValue(navIndex);
    const hexDetailId = useRecoilValue(hexDetailIdAtom);
    const mapData = useRecoilValue(mapDataAtom);
    const hexData = mapData.hexes.find(hex => hex.id === hexDetailId);

    if (hexData !== undefined) {
        const components = [
            <Info data={hexData} />,
            <NPCs data={hexData.npcs} />,
            <Bestiary data={hexData.bestiary} />,
            <Items data={hexData.items} />,
        ];

        return <>
            {components[index]}
        </>;
    }
    else {
        return <div>NO DATA</div>;
    }
}